// src/pages/PainelChamados/MenuTipoServico.jsx
import { motion } from "framer-motion";
import { Save, XCircle } from "lucide-react";

export default function MenuTipoServico({ onSalvar, onCancelar }) {
  const buttonStyle =
    "w-32 py-2 rounded-md text-white font-semibold shadow-md mx-auto flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed transition-transform duration-200";

  return (
    <motion.div
      initial={{ x: 50, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: 50, opacity: 0 }}
      transition={{ duration: 0.3 }}
      className="flex flex-col gap-3 items-center justify-start h-full p-4"
    >
      {/* Botões */}
      <div className="flex flex-col gap-3 items-center">
        <button
          onClick={onSalvar}
          className={`${buttonStyle} hover:scale-105`}
          style={{ backgroundColor: "#16a34a" }}
        >
          <Save size={16} /> Salvar
        </button>

        <button
          onClick={onCancelar}
          className={`${buttonStyle} hover:scale-105`}
          style={{ backgroundColor: "#b50000" }}
        >
          <XCircle size={16} /> Cancelar
        </button>
      </div>
    </motion.div>
  );
}
